import React, { useRef } from "react";
import Popup from "../../components/ui/SuccessPopup";
import { useBlogPost } from "../../contexts/blog/PostBlogContext";
import HeroImageSection from "./sections/HeroImageSection";
import CategorySection from "./sections/CategorySection";
import TitleSection from "./sections/TitleSection";
import MetaSection from "./sections/MetaSection";
import ContentSection from "./sections/ContentSection";
import FAQSection from "./sections/FAQSection";
import StatusSection from "./sections/StatusSection";
import SubmitButton from "./sections/SubmitButton";

export default function PostBlog() {
  const {
    formData,
     setFormData,
    errors,
    loading,
    popup,
    handleInputChange,
    handleImageChange,
    handleAltTextChange,
    handleAddContent,
    handleAddFAQ,
    handleDeleteContent,
    handleDeleteFAQ,
    handleEditorChange,
    handleSubmit,
    setPopup,
  } = useBlogPost();

  const refs = {
    HeroImg: useRef(null),
    HeroAltText: useRef(null),
    Category: useRef(null),
    SubCategory: useRef(null),
    Tags: useRef(null),
    Title: useRef(null),
    Subtitle: useRef(null),
    Slug: useRef(null),
    MetaTitle: useRef(null),
    MetaDescription: useRef(null),
    MetaKeywords: useRef(null),
    status: useRef(null),
    ScheduledDate: useRef(null),
  };

  return (
    <>
      <div className="max-w-5xl mx-auto p-8 bg-white rounded-xl shadow-lg">
        <h1 className="text-4xl font-extrabold mb-8 border-b pb-4">
          Create New Blog Post
        </h1>

        <HeroImageSection {...{ formData, errors, refs, handleImageChange, handleInputChange }} />
        <CategorySection {...{ formData, errors, refs, handleInputChange, setFormData, }} />
        <TitleSection {...{ formData, errors, refs, handleInputChange }} />
        <MetaSection {...{ formData, errors, refs, handleInputChange }} />

        <ContentSection
          {...{
            formData,
            errors,
            handleEditorChange,
            handleAddContent,
            handleDeleteContent,
            handleImageChange,      // ✅ ADD THIS
            handleAltTextChange,
          }}
        />

        <FAQSection
          {...{
            formData,
            handleAddFAQ,
            handleDeleteFAQ,
            handleInputChange,
          }}
        />

        <StatusSection {...{ formData, errors, refs, handleInputChange }} />

        <SubmitButton
          loading={loading}
          status={formData.status}
          onSubmit={() => handleSubmit(refs)}
        />
      </div>

      <Popup
        open={popup.open}
        type={popup.type}
        message={popup.message}
        onClose={() => setPopup((p) => ({ ...p, open: false }))}
      />
    </>
  );
}
